/* import __COLOCATED_TEMPLATE__ from './set-expectations.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();